import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import PhoneInput from "react-phone-input-2";

import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { toastAlert } from "../../lib/toastAlert";
import ConnectWallet from "./connectwallet";
//import avatar from "assets/img/faces/marc.jpg";
import isEmpty from "../../lib/isEmpty";
import Web3 from "web3";
import Web3Modal from "web3modal";
import { providerOptions } from "../../actions/providerOptions";
import { addwhitelist, updatepricecnv } from "../../actions/users";
import UPRO_ABI from "./UPRO_ABI.json";
const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

// toaster config
toast.configure();
let toasterOption = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const initialFormValue = {
  address: "",
};

const useStyles = makeStyles(styles);

export default function Categoryadd(props) {
  const classes = useStyles();
  const history = useHistory();
  const [toched, setToched] = useState({});

  const dispatch = useDispatch();
  const [walletconnect, setwalletconnect] = useState();
  const [formValue, setFormValue] = useState(initialFormValue);
  const [validateError, setValidateError] = useState({});

  const { userId } = useParams();
  const [Loader, setLoader] = useState(false);
  const [tokenprice, settokenprice] = useState("");

  const web3Modal = new Web3Modal({
    providerOptions, // required,
    cacheProvider: true, // optional
  });

  const onChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    let formData = { ...formValue, ...{ [id]: value } };
    setFormValue(formData);
    settokenprice(value);
    // console.log(formValue);
  };

  const { address } = formValue;

  useEffect(() => {}, [walletconnect]);

  useEffect(() => {
    getTokenprice();
  }, []);
  const getTokenprice = async () => {
    try {
      var web3 = new Web3("https://mainnet-rpc.ultraproscan.io/");
      let contractAddr = "0x5F581cbbE5D96B19A19D3c281D541Fe94cd255FD";
      var Contract = new web3.eth.Contract(UPRO_ABI, contractAddr);
      var tokenprice = await Contract.methods.tokenPerUsd().call();
      settokenprice(tokenprice / 100000000);
    } catch (err) {}
  };

  const handleFormSubmit = async (e) => {
    console.log("saran kkdkfkdf");
    e.preventDefault();
    setLoader(true);
    // console.log(formValue);

    if (isEmpty(tokenprice)) {
      toastAlert("error", "Please Enter Price", "address");
      setLoader(false);

      return;
    }

    if (isEmpty(walletconnect)) {
      toastAlert("error", "Please Connect Metamask", "address");
      setLoader(false);

      return;
    }

    if (web3Modal.cachedProvider) {
      var provider = await web3Modal.connect();
      var web3333 = new Web3(provider);
      let getId = await web3333.eth.net.getId();
      console.log(getId, "getIdgetIdgetIdgetIdgetIdgetIdgetIdgetIdgetId");
      var contractAddr = "0x5F581cbbE5D96B19A19D3c281D541Fe94cd255FD";

      if (provider && provider?.on) {
        try {
          let result = await web3333.eth.getAccounts();
          var metamaskAddress = result[0];
          console.log(metamaskAddress, "metamaskAddress", contractAddr);
          var Contract = new web3333.eth.Contract(UPRO_ABI, contractAddr);
          var owner_address = await Contract.methods.OwnerWallet().call();
          console.log(owner_address, "owner_address");

          if (owner_address != metamaskAddress) {
            toastAlert(
              "error",
              "Please Connect Correct Admin wallet",
              "address"
            );
            setLoader(false);

            return;
          }
        } catch (err) {
          console.log(err);
          toastAlert("error", "Something went wrong", "address");
          setLoader(false);

          return;
        }
      }
    }

    // console.log(reqData);

    try {
      let price = tokenprice * 100000000;
      var addwlist = await Contract.methods
        .setTokenPrice(price)
        .send({ from: metamaskAddress });
      console.log(addwlist, "---addwlist");

      let reqData = { price: tokenprice };
      await updatepricecnv(reqData);

      toastAlert("success", "Token Price Updated successfully", "address");
      setLoader(false);

      history.push("/priceupdate");
    } catch (err) {
      console.log(err, "-----163");
      toastAlert("error", "Error on contract", "address");
      setLoader(false);
    }
  };

  let formdata = {};

  return (
    <div>
      <ConnectWallet setwalletconnect={setwalletconnect} />
      {console.log(walletconnect, "------setwalletconnect")}
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <form
              className={classes.form}
              noValidate
              onSubmit={handleFormSubmit}
            >
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Token Price Update</h4>
                {/* <p className={classes.cardCategoryWhite}>Create a new user</p> */}
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      onChange={onChange}
                      id="address"
                      labelText="Price"
                      value={address ? address : tokenprice}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                    {toched.address && validateError.address && (
                      <p className="error-message">{validateError.address}</p>
                    )}
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Button color="primary" type="submit" disabled={Loader}>
                  Update
                </Button>
              </CardFooter>
            </form>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
